/* eslint-disable jest/valid-describe */
/* eslint-disable jest/valid-title */
import React from 'react';
import { styled, textStyle, truncate, color } from '@elliemae/ds-system';
import { describe, PropTypes } from '@elliemae/ds-props-helpers';

const Text = styled.p`
  margin: auto 0;
  ${truncate()}
  ${textStyle('body')}
  ${color('neutral', '800')}
`;

const DSMobileFooterText = ({ children }) => <Text>{children}</Text>;

const props = {
  children: PropTypes.string.isRequired.description('Children'),
};

DSMobileFooterText.displayName = 'DSMobileFooterText';
const DSMobileFooterTextWithSchema = describe(DSMobileFooterText);
DSMobileFooterTextWithSchema.propTypes = props;

export { DSMobileFooterText, DSMobileFooterTextWithSchema };
